module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c013"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }), _c('b', [_vm._v("1801")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter0"
  }, [_vm._v("The Jacquard Loom")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent_line"
  }, [_c('b', [_vm._v("Joseph-Marie Jacquard")]), _vm._v(" (1752–1834)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("In 1801, French weaver Joseph-Marie Jacquard invented a way to accelerate and simplify the time-consuming, complex task of weaving fabric. His technique was the conceptual precursor to binary logic and programming that exists today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While looms of the 18th century could create complex patterns, doing so was an entirely manual affair, requiring an extraordinary amount of time, constant vigilance to avoid mistakes, and skilled hands—especially with intricate fabric patterns such as damask and brocade. Jacquard realized that despite the complexity of a pattern, the act of weaving was a repetitive process that could be carried out mechanically. His invention used a series of cards laced together in a continuous chain, with a row on each card where holes could be punched, corresponding with one row of the fabric pattern. Some cards had holes in the specified position, while others did not. Essentially, the punched cards were a control mechanism that contained data—like binary 0s and 1s—that directed a sequence of actions, in this case how a loom could be mechanized to weave a repeating pattern. A hole would cause a corresponding thread to be raised, while no hole would cause the thread to be lowered. The actual mechanism involved a rod that would either travel through the hole or be stopped by the card; each rod was linked to a hook, and together they formed the harness that controlled the position of the threads. After the threads were raised or lowered, the shuttle holding another roll of thread would zip from one side of the loom to the other, completing the weave. Then the rods in the holes would retract, the card would advance, and the process would start over again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jacquard’s invention evolved from earlier ideas by Jacques de Vaucanson (1709–1782), Jean-Baptiste Falcon, and Basile Bouchon, the last of whom invented a way to control a loom using perforated tape in 1725. Later inventors would take that concept and use punched cards to represent numerical data and other types of information.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('b', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c024_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tabulating the US Census (1890)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("A jacquard loom in the National Museum of Scotland, Edinburgh. Pins either are stopped by the card or poke through the holes, determining the pattern woven by the loom.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/41-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af7fd01a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_c013_r1.vue
// module id = 111
// module chunks = 0